<script>
import validationMessages from "@/components/validations";
import { required } from "vuelidate/lib/validators";
import Monitor from "@/services/Monitor";
import Aws from "../../../../services/Aws";

export default {
  components: {
    validationMessages,
  },
  props: {
    modalData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
      tryingToSubmit: false,
      submitted: false,
      tenants: [],
      instances: [],
      id: "",
      selectedTenant: "",
      command: "",
      expression: "",
      params: "",
      laravel_expression: "",
      background: 1,
      environment: "",
      description: "",
      server: "",
      active: 0,
      critical: 0,
      envs: ["prod", "dev"],
      csrf_token: localStorage.getItem("csrf_token"),
    };
  },
  validations: {
    command: { required },
    expression: { required },
    description: { required },
  },
  methods: {
    openModal() {
      this.syncData();
      this.getTenants();
      this.getInstances();
    },
    syncData() {
      this.command = this.modalData.command;
      this.expression = this.modalData.expression;
      this.params = this.modalData.params;
      this.laravel_expression = this.modalData.laravel_expression;
      this.background = this.modalData.background;
      this.environment = this.modalData.environment;
      this.description = this.modalData.description;
      this.server = this.modalData.server;
      this.active = this.modalData.active;
      this.critical = this.modalData.critical;
      this.selectedTenant = this.modalData.tenant;
      this.id = this.modalData.id;
    },

    resetProps() {
      this.submitted = false;
      this.tenants = [];
      this.command = "";
      this.expression = "";
      this.params = "";
      this.laravel_expression = "";
      this.background = 1;
      this.environment = "";
      this.description = "";
      this.server = "";
      this.active = 0;
      this.critical = 0;
      this.selectedTenant = "";
      this.instances = [];
      this.id = "";
    },
   async getInstances() {
      try {
        const response = await Aws.getInstances();
        this.instances = response.data.data.filter(
          (item) => item.State === "running" && item.user_tags !== null ? item.user_tags.includes("cron") : false
        );
      } catch (error) {
        console.log(error, "error");
      }
    },
    refreshData() {
      this.$emit("onRefresh"); //event from parent
    },
    closeModal() {
      this.showModal = false;
    },
    getTenants() {
      Monitor.getTenants()
        .then((response) => {
          this.tenants = response.data.tenants;
        })
        .catch((error) => {});
    },

    editCronTask() {
      this.tryingToSubmit = true;
      this.submitted = true;
      this.tryingToSubmit = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.tryingToSubmit = false;
        return;
      }

      const changedFields = {};

      changedFields.id = this.id;

      // Compare each field with the original data and only include if changed
      if (this.command !== this.modalData.command) {
        changedFields.command = this.command;
      }
      if (this.selectedTenant !== this.modalData.tenant) {
        changedFields.tenant = this.selectedTenant;
      }
      if (this.params !== this.modalData.params) {
        changedFields.params = this.params;
      }
      if (this.expression !== this.modalData.expression) {
        changedFields.expression = this.expression;
      }
      if (this.laravel_expression !== this.modalData.laravel_expression) {
        changedFields.laravel_expression = this.laravel_expression;
      }
      if (this.background !== this.modalData.background) {
        changedFields.background = this.background;
      }
      if (this.environment !== this.modalData.environment) {
        changedFields.environment = this.environment;
      }
      if (this.description !== this.modalData.description) {
        changedFields.description = this.description;
      }
      if (this.server !== this.modalData.server) {
        changedFields.server = this.server;
      }
      if (this.active !== this.modalData.active) {
        changedFields.active = this.active;
      }
      if (this.critical !== this.modalData.critical) {
        changedFields.critical = this.critical;
      }

      Monitor.editCronScheduleTask(changedFields)
        .then((response) => {
          const res = response.data ? response.data : false;
          const error = response.data.error ? response.data.error : "";
          if (res) {
            this.successmsg("Schedule Task Updated Successfully!");
            this.refreshData();
            this.closeModal();
          } else {
            this.failedmsg("Failed to update the scheduled task!");
          }
        })
        .catch((error) => {
          const resData = error.response.data.error
            ? error.response.data.error
            : "Failed";
          const errorMsg = Array.isArray(resData) ? resData[0] : resData;
          this.failedmsg(errorMsg);
        })
        .finally(() => {
          this.tryingToSubmit = false;
        });
    },
  },
};
</script>

<template>
  <b-modal
    id="edit_cron_schedule_task"
    size="md"
    v-model="showModal"
    @shown="openModal()"
    @hidden="resetProps"
    title="Edit Cron Scheduled Task"
    title-class="font-18"
  >
    <form @submit.prevent="editCronTask()">
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label class="control-label form-label">Command *</label>
            <b-form-input
              v-model="command"
              :class="{
                'is-invalid': submitted && $v.command.$error,
              }"
            ></b-form-input>
            <validationMessages
              v-if="submitted"
              :fieldName="'Command'"
              :validationName="$v.command"
            ></validationMessages>
          </div>
          <div class="mb-3">
            <label class="control-label form-label">Tenant</label>
            <select
              v-model="selectedTenant"
              class="form-control form-select"
              name="option"
              type="select"
            >
              <option v-for="tenant in tenants" :key="tenant" :value="tenant">
                {{ tenant }}
              </option>
            </select>
          </div>

          <div class="mb-3">
            <label class="control-label form-label">Params</label>
            <b-form-input v-model="params"></b-form-input>
          </div>
          <div class="mb-3">
            <label class="control-label form-label">Expression *</label>
            <b-form-input
              v-model="expression"
              :class="{
                'is-invalid': submitted && $v.expression.$error,
              }"
            ></b-form-input>
            <validationMessages
              v-if="submitted"
              :fieldName="'Expression'"
              :validationName="$v.expression"
            ></validationMessages>
          </div>
          <div class="mb-3">
            <label class="control-label form-label">Laravel Expression</label>
            <b-form-input v-model="laravel_expression"></b-form-input>
          </div>
          <div class="col-sm-12 col-md-4">
            <label class="control-label form-label">Background</label>
            <b-form-checkbox-group>
              <div class="form-check form-switch form-switch-lg mb-3">
                <input
                  v-model="background"
                  type="checkbox"
                  class="form-check-input"
                  id="switch1"
                  true-value="1"
                  false-value="0"
                />
              </div>
            </b-form-checkbox-group>
          </div>
          <div class="mb-3">
            <label class="control-label form-label">Environment</label>
            <select
              v-model="environment"
              class="form-control form-select"
              name="option"
              type="select"
            >
              <option v-for="env in envs" :key="env" :value="env">
                {{ env }}
              </option>
            </select>
          </div>
          <div class="mb-3">
            <label class="control-label form-label">Description *</label>
            <b-form-input
              v-model="description"
              :class="{
                'is-invalid': submitted && $v.description.$error,
              }"
            ></b-form-input>
            <validationMessages
              v-if="submitted"
              :fieldName="'Description'"
              :validationName="$v.description"
            ></validationMessages>
          </div>
          <div class="mb-3">
            <label class="control-label form-label">Server</label>
            <select
              v-model="server"
              class="form-control form-select"
              name="option"
              type="select"
            >
              <option
                v-for="instace in instances"
                :key="instace.InstanceId"
                :value="instace.InstanceId"
              >
                {{
                  instace.Tags[0].Key !== "Name"
                    ? ""
                    : `${instace.InstanceId} |`
                }}
                {{
                  instace.Tags[0].Key === "Name"
                    ? instace.Tags[0].Value
                    : instace.InstanceId
                }}
              </option>
            </select>
          </div>
          <div class="row">
            <div class="col-sm-6 col-md-4">
              <label class="control-label form-label">Active</label>
              <b-form-checkbox-group>
                <div class="form-check form-switch form-switch-lg mb-3">
                  <input
                          v-model="active"
                          type="checkbox"
                          class="form-check-input"
                          true-value="1"
                          false-value="0"
                  />
                </div>
              </b-form-checkbox-group>
            </div>

            <div class="col-sm-6 col-md-4">
              <label class="control-label form-label">Critical</label>
              <b-form-checkbox-group>
                <div class="form-check form-switch form-switch-lg mb-3">
                  <input
                          v-model="critical"
                          type="checkbox"
                          class="form-check-input"
                          true-value="1"
                          false-value="0"
                  />
                </div>
              </b-form-checkbox-group>
            </div>
          </div>

        </div>
      </div>
      <input type="hidden" name="csrf_token" v-model="csrf_token" />
    </form>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
      <b-button
        variant="primary"
        @click="editCronTask"
        :disabled="tryingToSubmit"
      >
        <b-spinner v-show="tryingToSubmit" small></b-spinner>
        Submit
      </b-button>
    </template>
  </b-modal>
</template>
